<template>
<div>
<el-table
    :data="tableData"
    style="width: 100%"
    @row-click="handleRowClick"
    :row-class-name="customRowClass"
    :class="getPrimaryColor"
    :header-row-class-name="'company-table-header'"
>
<!--     <el-table-column width="80px" label="">
        <template slot-scope="scope">
        </template>
    </el-table-column> -->
    <el-table-column prop="tradingName" sortable min-width="200px" label="Nome da empresa">
        <template slot-scope="scope">
            <NameInitials :name="scope.row.tradingName || scope.row.name" small/>
            <el-tooltip :content="scope.row.name" placement="top">
                <p class="c-ndarkfour pt-2 pr-4 medium break company-break d-inline-block">
                    {{ (scope.row.tradingName || scope.row.name) | formatName }}
                </p> 
            </el-tooltip>
        </template>
    </el-table-column>
    <el-table-column prop="cnpj" sortable :sort-method="sortColumnCnpj" min-width="160px" label="cnpj" v-if="companyType !== '1'">
        <template slot-scope="scope">
            <p class="medium c-ndarkfour mb-0">
                {{ scope.row.cnpj.cnpj | formatCnpjOrCpf }}
            </p>
        </template>
    </el-table-column>
    <el-table-column prop="partners.size" min-width="120px" label="Parceiros" v-if="companyType === '1' && USER_TYPE_MIXIN.isAdm" sortable>
        <template slot-scope="scope" >
            <el-tooltip placement="bottom" v-if="scope.row.partners.length">
                <p slot="content" v-for="partner in scope.row.partners" :key="scope.row.cnpj.cnpj + partner">
                    {{ getPartners[partner] }}
                </p> 
                <p class="medium c-ndarkfour mb-0 d-inline-block">
                    {{ scope.row.partners.length | formatNumberWithZero }} parceiro{{scope.row.partners.length === 1 ? '' : 's'}}
                </p>
            </el-tooltip>
            <p class="medium c-ndarkfour mb-0" v-else>
                0 parceiros
            </p>
        </template>
    </el-table-column>
    <el-table-column prop="partners" min-width="120px" label="Parceiro" v-if="companyType === '2' && USER_TYPE_MIXIN.isAdm">
        <template slot-scope="scope" >
            <p v-for="partner in scope.row.partners" :key="scope.row.cnpj.cnpj + partner" class="medium c-ndarkfour mb-0">
                {{ getPartners[partner] }}
            </p> 
        </template>
    </el-table-column>
    <el-table-column prop="economicGroups.length" min-width="150px" label="Grupos Econômicos" v-if="companyType === '1'" sortable>
        <template slot-scope="scope" >
            <el-tooltip placement="bottom" v-if="scope.row.economicGroups.length">
                <p slot="content" v-for="economicGroup in scope.row.economicGroups" :key="scope.row.cnpj.cnpj + economicGroup.id">
                    {{ economicGroup.name }}
                </p> 
                <p class="medium c-ndarkfour mb-0 d-inline-block">
                    {{ scope.row.economicGroups.length | formatNumberWithZero }} grupo{{scope.row.economicGroups.length === 1 ? '' : 's'}}
                </p>
            </el-tooltip>
            <p class="medium c-ndarkfour mb-0" v-else>
                0 grupos
            </p>
        </template>
    </el-table-column>
    <el-table-column prop="economicGroups" min-width="150px" label="Grupos Econômicos" v-if="companyType === '2'">
        <template slot-scope="scope" >
            <p class="medium c-ndarkfour mb-0" v-for="economicGroup in scope.row.economicGroups" :key="scope.row.cnpj.cnpj + economicGroup.id">
                {{ economicGroup.name | formatName}}
            </p> 
        </template>
    </el-table-column>
    <el-table-column prop="users.length" min-width="120px" label="usuários" v-if="companyType !== '2'" sortable>
        <template slot-scope="scope" >
            <p class="medium c-ndarkfour mb-0">
                {{ scope.row.users.length | formatNumberWithZero }} usuário{{scope.row.users.length === 1 ? '' : 's'}}
            </p>
        </template>
    </el-table-column>
    <el-table-column prop="cnpj.registerComplete" sortable :sort-method="sortColumnStatus" min-width="100px" label="status" v-if="companyType !== '2'">
        <template slot-scope="scope">
            <CompanyStatus 
                :cnpjId="scope.row.cnpjId" 
                :status="scope.row.cnpj.registerComplete" 
                :registerActive="scope.row.cnpj.registerActive"
            />
        </template>
    </el-table-column>
    <el-table-column prop="canOperate" min-width="120px" label="antecipação" v-if="companyType === '1'" sortable>
        <template slot-scope="scope">
            <el-tooltip placement="bottom">
                <SuccessCircle class="ml-4" :color="canOperate(scope.row) ? '#33BDA3' : '#DFE2EB'" :circleColor="canOperate(scope.row) ? '#33BDA3' : '#DFE2EB'" />
                <p slot="content">
                    {{ canOperate(scope.row) ? 'Antecipação habilitada' : 'Antecipação desabilitada' }}
                </p>
            </el-tooltip>
        </template>
    </el-table-column>
    <el-table-column min-width="100px" label="">
        <template slot-scope="scope">
            <div class="d-flex justify-content-end">
                <el-dropdown trigger="click" :hide-on-click="false">
                    <Button type="secondary" size="small" :color="getPrimaryColor">Ações</Button>
                    <el-dropdown-menu slot="dropdown" :color="getPrimaryColor" class="min-width-240" :class="USER_TYPE_MIXIN.isBackOffice && scope.row.cnpj.companyType === '2' ? 'p-0' : ''">
                        <ActionBtnItemsContainer :withoutBottomLine="USER_TYPE_MIXIN.isBackOffice && scope.row.cnpj.companyType === '2'">
                            <el-dropdown-item >
                                <span
                                    class="c-ndarkthree medium pl-3 pr-3 d-flex align-items-center"
                                    :class="scope.row.cnpj.companyType != '1' && scope.row.cnpj.registerActive != null ? 'mb-1' : ''"
                                    @click="gotoDetails(scope.row)"
                                >
                                    <Edit class="mr-2" />
                                    <!-- <Eye class="mr-2" size="16" color="#A1A8B8" /> -->
                                    {{  editLabel(scope.row.cnpj.companyType) }}
                                </span>
                            </el-dropdown-item>
                            <el-dropdown-item v-if="scope.row.cnpj.registerComplete == 2 || scope.row.cnpj.registerComplete == 3">
                                <span class="c-ndarkthree medium pl-3 d-flex align-items-center" @click="sendReview(scope.row.cnpjId)">
                                    <Chat class="mr-2"/>Enviar mensagem
                                </span>
                            </el-dropdown-item>
                            <el-dropdown-item v-if="scope.row.cnpj.companyType !== '2' && scope.row.cnpj.registerActive != null">
                                <el-dropdown placement="left" >
                                    <span class="c-ndarkthree medium pl-3 pr-3 d-flex align-items-center">
                                        <Clock class="mr-2"/>Alterar status do cadastro
                                        <ArrowDropdown class="ml-4" :rotate="270" />
                                    </span>
                                    <el-dropdown-menu  slot="dropdown">
                                        <el-dropdown-item>
                                            <span class="c-ndarkthree medium pl-3 d-flex align-items-center" @click="handleClick(0, scope.row, scope.row.partners)">
                                                <Sphere :color="'#FFAC00'" class="sphere mr-1" :size="'12'" /> Pendente
                                            </span>
                                        </el-dropdown-item>
                                        <el-dropdown-item>
                                            <span class="c-ndarkthree medium pl-3 d-flex align-items-center" @click="handleClick(2, scope.row, scope.row.partners)">
                                                <Sphere :color="'#FFAC00'" class="sphere mr-1" :size="'12'" /> Em análise
                                            </span>
                                        </el-dropdown-item>
                                        <el-dropdown-item>
                                            <span class="c-ndarkthree medium pl-3 d-flex align-items-center" @click="handleClick(3, scope.row, scope.row.partners)">
                                                <Sphere :color="'#FFAC00'" class="sphere mr-1" :size="'12'" /> Em revisão
                                            </span>
                                        </el-dropdown-item>
                                        <el-dropdown-item>
                                            <span class="c-ndarkthree medium pl-3 d-flex align-items-center" @click="handleClick(1, scope.row, scope.row.partners)">
                                                <Sphere :color="'#33BDA3'" class="sphere mr-1" :size="'12'" /> Completo
                                            </span>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </el-dropdown-item>
                            <el-dropdown-item v-if="scope.row.cnpj.companyType == '1' && canOperate(scope.row) && scope.row.cnpj.partner.partnerCnpjs">
                                <span class="c-ndarkthree medium pl-3 d-flex align-items-center" :class="scope.row.cnpj.companyType == '1' || scope.row.cnpj.registerActive != null ? 'mt-n1' : ''" @click="changeCompanyCanOperate(scope.row)">
                                    <Delete :strokeWidth="1" color="#A1A8B8" class="mr-2"/>Desabilitar antecipação
                                </span>
                            </el-dropdown-item>
                            <el-dropdown-item v-if="scope.row.cnpj.companyType == '1' && !canOperate(scope.row) && scope.row.cnpj.partner.partnerCnpjs">
                                <span class="c-ndarkthree medium pl-3 d-flex align-items-center" :class="scope.row.cnpj.companyType == '1' || scope.row.cnpj.registerActive != null ? 'mt-n1' : ''" @click="changeCompanyCanOperate(scope.row)">
                                    <CheckPayment color="#A1A8B8" class="mr-2 ml-n15" size="20" />Habilitar antecipação
                                </span>
                            </el-dropdown-item>
                        </ActionBtnItemsContainer>
                        <ActionBtnItemsContainer :withoutBottomLine="!USER_TYPE_MIXIN.isAdm">
                            <el-dropdown-item v-if="scope.row.cnpj.companyType == '1'">
                                <span class="c-ndarkthree medium pl-3 pr-4 d-flex align-items-center" @click="downloadAll(scope.row.id)">
                                    <Download size="16" color="#A1A8B8" class="mr-2"/>Baixar documentos do cadastro
                                </span>
                            </el-dropdown-item>
                        </ActionBtnItemsContainer>
                        <ActionBtnItemsContainer withoutBottomLine v-if="USER_TYPE_MIXIN.isAdm">
                            <el-dropdown-item v-if="scope.row.cnpj.registerActive == true">
                                <span class="c-ndarkthree medium pl-3 d-flex align-items-center" @click="changeCompanyIsActive(scope.row.cnpjId, false)">
                                    <Delete :strokeWidth="1" color="#A1A8B8" class="mr-2"/>Desativar a empresa
                                </span>
                            </el-dropdown-item>
                            <el-dropdown-item v-if="scope.row.cnpj.registerActive == false">
                                <span class="c-ndarkthree medium pl-3 d-flex align-items-center" @click="changeCompanyIsActive(scope.row.cnpjId, true)">
                                    <CheckPayment color="#A1A8B8" class="mr-2"/>Ativar a empresa
                                </span>
                            </el-dropdown-item>
                        </ActionBtnItemsContainer>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </template>
    </el-table-column>
</el-table>
<SendReviewRegister :dialogVisible="dialogVisible" @closeModal="dialogVisible=$event" :cnpjId="cnpjId" @sendReview="sucessSendReview"/>
<CompanyCanOperate :dialogVisible="dialogVisibleCanOperate" @closeModal="dialogVisibleCanOperate= $event" :canOperate="currentCanOperate" @changeCanOperate="changeCanOperate"/>
<ChangeStatusRegister :dialogVisible="dialogVisibleStatus" @closeModal="dialogVisibleStatus = $event" @updateStatus="changeRegisterStatus()"/>

</div>
</template>

<script>
// import CountDown from "@/components/countdown/CountDown";
import CompanyStatus from '@/components/status/CompanyStatus'
//import DropdownIcon from '@/components/icons/Dropdown' 
import updateCanOperateCompany from '@/api/updateCanOperateCompany'
import CompanyCanOperate from '@/components/modals/CompanyCanOperate'
import SendReviewRegister from '@/components/modals/SendReviewRegister'
import downloadAllFilesProvider from '@/api/downloadAllFilesProvider'
import downloadArchive from '@/api/downloadArchive'
import updateRegisterStatusCompany from '@/api/updateRegisterStatusCompany'
import ChangeStatusRegister from '@/components/modals/ChangeStatusRegister'
import ActionBtnItemsContainer from '@/components/container/ActionBtnItemsContainer'
import getCompany from '@/api/getCompany'

// Icons
import NameInitials from '@/components/icons/NameInitials'
import Edit from '@/components/icons/Edit'
import Download from '@/components/icons/Download'
import Delete from '@/components/icons/Delete'
import CheckPayment from '@/components/icons/CheckPayment'
import Clock from '@/components/icons/Clock'
import ArrowDropdown from '@/components/icons/ArrowDropdown.vue'
import Sphere from '@/components/icons/Sphere'
import SuccessCircle from '@/components/icons/SuccessCircle'
import Chat from '@/components/icons/Chat'
// import Eye from '@/components/icons/Eye'

export default {
    components: {
    NameInitials,
    CompanyStatus,
    //DropdownIcon,
    Edit,
    Download,
    Delete,
    CompanyCanOperate,
    SendReviewRegister,
    // CountDown,
    CheckPayment,
    Clock,
    ArrowDropdown,
    ChangeStatusRegister,
    Sphere,
    SuccessCircle,
    ActionBtnItemsContainer,
    Chat,
    // Eye,
},
    props: {
        tableData: {
            required: true
        },
        companyType: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            dialogVisible: false,
            dialogVisibleCanOperate: false,
            currentCanOperate: true,
            cnpjId: null,
            economicGroupIds: [],
            dialogVisibleStatus: false,
            scopePartners: [],
        }
    },
    methods: {
        customRowClass({row}) {
            if (row.cnpj.registerActive == false) return 'disabled'
            else return ''
        },
        sendReview(cnpjId){
            this.cnpjId = cnpjId
            this.dialogVisible= true
        },
        sucessSendReview(){
            this.$emit('sucessSendReview', false)
        },
        sortColumnCnpj(a, b) {
            return parseInt(a.cnpj.cnpj) - parseInt(b.cnpj.cnpj)
        },
        sortColumnStatus(a, b) {
            return a.cnpj.registerComplete - b.cnpj.registerComplete
        },
        sortColumnName(a, b) {
            return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        },
        changeCompanyIsActive(cnpjId, active) {
            this.$emit('changeIsActive', { cnpjId, active })
        },
        changeCompanyCanOperate(row) {
            const { cnpjId, economicGroups } = row
            const companyCanOperate = this.canOperate(row)
            const economicGroupIds = economicGroups.map(({ id }) => id)
            
            this.economicGroupIds = economicGroupIds
            this.currentCanOperate = companyCanOperate
            this.cnpjId = cnpjId
            this.dialogVisibleCanOperate = true
        },
        formatTooltip(value) {
            let val = (value / 100).toFixed(2).toString().replace('.', ',')
            return `R$ ${val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")}`;
        },
        async handleRowClick(row, column) {
            if (!column || column.label != 'status de cadastro' && (column.minWidth != 100 && column.label != '' )) {
                this.gotoDetails(row)
            }
        },
        async gotoDetails(row) {
            this.$emit('persistFilter')

            const {  economicGroups } = row
            const economicGroupIds = economicGroups.map(({ id }) => id)

            this.$store.commit('register/setEconomicGroups', economicGroupIds)
            await getCompany({ cnpjId: row.cnpjId, companyType: row.cnpj.companyType })

            this.$store.commit('register/resetPartners')
            
            const type = row.cnpj.companyType == 0 ? 'sponsor' : row.cnpj.companyType == 1 ? 'provider' : 'buyer'

            this.$router.push(`/${type}/update/${row.cnpjId}/0`)
        },
        async changeCanOperate(boolean) {
            const result = await updateCanOperateCompany(this.cnpjId, { canOperate: boolean, economicGroupIds: this.economicGroupIds })
            if (result.status === 204) {
                if (boolean == true) {   
                    this.$notify({
                        title: 'Antecipação habilitada com sucesso!',
                        message: '',
                        type: 'success',
                        duration: 3000,
                        offset: 100,
                        showClose: false,
                    });
                } else {
                    this.$notify({
                        title: 'Antecipação desabilitada com sucesso!',
                        message: '',
                        type: 'success',
                        duration: 3000,
                        offset: 100,
                        showClose: false,
                    });
                }
                this.$emit('changedCanOperate')
                this.dialogVisibleCanOperate = false
            } else {
                this.$notify({
                    title: 'Ops, algo aconteceu de errado!',
                    message: '',
                    type: 'error',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                    customClass: 'error'
                });
                this.dialogVisibleCanOperate = false
            }
        },
        async downloadAll(id) {
            this.$store.commit('user/setIsDownloadLoading', true)

            const result = await downloadAllFilesProvider(id)
            downloadArchive(`${process.env.VUE_APP_ROOT_API}/${result}`)

            setTimeout(() => {
                this.$store.commit('user/setIsDownloadLoading', false)
            }, 8000)
        },
        async changeRegisterStatus() {
            const result = await updateRegisterStatusCompany(this.cnpjId, { status: this.statusToChange, partners: this.scopePartners }, this.getWhiteLabel)
            if (result.ok) {
                this.$notify({
                    title: 'Status alterado com sucesso!',
                    message: '',
                    type: 'success',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                });
                const companies =  this.$store.state.companies.companies.map((company) => {
                    if (company.cnpjId == this.cnpjId) {
                        company.cnpj.registerComplete = this.statusToChange
                        return company
                    } else {
                        return company
                    }
                })

                this.$store.commit('companies/setCompanies', companies)
                this.dialogVisibleStatus = false

                // if (this.statusToChange == 1 && this.companyType == 1 && this.economicGroupIds.length > 0) {
                //     await updateCanOperateCompany(this.cnpjId, { canOperate: 1, economicGroupIds: this.economicGroupIds })
                //     this.$emit('changedCanOperate')
                // }

                // if que altera o canOperate se o status for alterado
                // if (this.statusToChange != 1 && this.companyType == 1 && this.economicGroupIds.length > 0) {
                //     await updateCanOperateCompany(this.cnpjId, { canOperate: 0, economicGroupIds: this.economicGroupIds })
                //     this.$emit('changedCanOperate')
                // }

                window.location.reload()
            } else {
                this.$notify({
                    title: 'Ops, algo aconteceu de errado!',
                    message: '',
                    type: 'error',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                    customClass: 'error'
                });
                this.dialogVisibleStatus = false
            }
        },
        handleClick(status, row, partners) {
            const { cnpjId, economicGroups } = row
            this.cnpjId = cnpjId
            this.statusToChange = status
            this.dialogVisibleStatus = true
            this.scopePartners = partners

            const economicGroupIds = economicGroups.length > 0 ? economicGroups.map(({ id }) => id) : []
            
            this.economicGroupIds = economicGroupIds
        },
        canOperate(row) {
            return row.cnpj.partner?.partnerCnpjs?.canOperate
        },
        editLabel(companyType) {
            const start = 'Editar' // this.USER_TYPE_MIXIN.isBackOffice ? 'Visualizar' : 'Editar'
            const middle = ' dados'
            const end = companyType === '1' ? ' cadastrais' : ''

            return start + middle + end
        }
    },
}
</script>

<style scoped >
    .sphere {
        stroke: none !important;
    }
    .min-width-240 {
        min-width: 240px;
    }
</style>

<style lang="scss">
    .el-table .company-table-header .el-table__header-wrapper .el-table__header thead tr th:first-child {
        padding-left: 25px !important;
    }
    .company-table-header th{
        padding-top: 0px !important;
        padding-bottom: 4px !important;
    }
    .el-dropdown-menu .popper__arrow {
        display: none !important;
    }
    .ml-n15 {
        margin-left: -0.15rem;
    }
</style>